//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';

export default {
  props: {
    value: { type: Boolean, default: false },
    currencies: { type: Array, default: () => [] },
    initialFees: { type: Array, default: () => [] },
  },

  data() {
    return {
      localFees: [],
      adminAmountFee: null,
      search: '',
    };
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },

    filteredFees() {
      const q = (this.search || '').toString().toLowerCase().trim();
      if (!q) return this.localFees;
      return this.localFees.filter((f) => {
        const title = (f.currencyTitle || '').toString().toLowerCase();
        return title.includes(q);
      });
    },
  },

  watch: {
    initialFees: {
      immediate: true,
      handler(val) {
        this.localFees = Array.isArray(val) ? JSON.parse(JSON.stringify(val)) : [];
        this.adminAmountFee = (this.localFees[0] && this.localFees[0].adminAmountFee) || null;
      },
    },

    adminAmountFee(val) {
      if (this.localFees && this.localFees[0]) {
        this.$set(this.localFees[0], 'adminAmountFee', val);
      }
    },
  },

  methods: {
    ...mapActions('cryptomatsFees', ['updateFees', 'loadFees']),

    hideModal() {
      this.model = false;
    },

    async submitFees() {
      const payload = {
        currencyFeeModels: (this.localFees || []).map((fee) => ({
          currencyTitle: fee.currencyTitle,
          simpleBlockchainFee: fee.simpleBlockchainFee,
          priorityBlockchainFee: fee.priorityBlockchainFee,
        })),
        adminAmountFee: (this.localFees[0] && this.localFees[0].adminAmountFee) || this.adminAmountFee,
      };

      const res = await this.updateFees(payload);
      if (res) {
        this.hideModal();
        await this.loadFees();
      }
    },
  },
};
